import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/modules/auth/services/auth/auth.service';
import { LoaderService } from '../../core/services/loader/loader.service';
import { CommonModule } from '@angular/common';
import { XdsProgressComponent } from 'src/app/shared/ui';
import { LanguageService, LANGUAGE_OPTIONS, LanguageOption } from '../../core/services/language/language.service';
import { TerminalAbmeldungService } from 'src/app/modules/terminal/services/terminal-abmeldung.service';
import { TerminalPinProtectionService } from 'src/app/modules/terminal/services/terminal-pin-protection.service';

@Component({
    selector: 'app-page-header-terminal',
    templateUrl: './page-header-terminal.component.html',
    styleUrls: ['./page-header-terminal.component.css'],
    imports: [
        CommonModule,
        TranslateModule,
        XdsProgressComponent
    ]
})
export class PageHeaderTerminalComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  /** Auswaehlbare Sprachen (zentrale Quelle, siehe LanguageService). */
  readonly languages: ReadonlyArray<LanguageOption> = LANGUAGE_OPTIONS;
  currentRoute: string;
  isRegisteredStepper: boolean = false;
  constructor(
    public authService: AuthService,
    public loaderService: LoaderService,
    private changeDetectorRef: ChangeDetectorRef,
    private translate: TranslateService,
    private languageService: LanguageService,
    private terminalPinProtection: TerminalPinProtectionService,
    private terminalAbmeldung: TerminalAbmeldungService
  ) {}
  public loading = false;
  public isMenuCollapsed = true;
  openShiftNumber = 0;
  lang;
  ngOnInit(): void {
    this.changeDetectorRef.detach();
    this.loaderService.isLoading
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.loading = res > 0;
        this.changeDetectorRef.detectChanges();
      });

    this.lang = LanguageService.normalize(this.translate.currentLang);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async changeLocale(lang: string): Promise<void> {
    // Dieselbe Prüfung wie in der Aktionsleiste. Bis zum 23.09.2026 lief der Sprachwechsel
    // hier ohne Admin-PIN — die Kopfzeile ist vom Dashboard verdeckt, aber per Tastatur
    // erreichbar.
    if (!(await this.terminalPinProtection.validateActionAccess('changeLocale'))) {
      this.isMenuCollapsed = true;
      return;
    }
    // Zentral normalisieren + persistieren — Terminal-Header lebt im Kiosk-
    // Modus und nutzt keinen UserSettings-Roundtrip. LocalStorage wird vom
    // LanguageService synchron geschrieben, der anschliessende Reload sieht
    // dann den kanonischen Short-Code (kein 'de-DE' mehr im Storage).
    this.languageService.applyLanguage(lang);
    window.location.reload();
    this.isMenuCollapsed = true;
  }

  async onLogoutClick(): Promise<void> {
    this.isMenuCollapsed = true;
    // Bis zum 23.09.2026 meldete dieser Knopf OHNE jede Prüfung ab. Jetzt derselbe Weg wie
    // auf dem Dashboard (Rückfrage bzw. Admin-PIN, Kiosk beenden).
    if (this.authService.isTerminal) {
      await this.terminalAbmeldung.abmelden('header');
      return;
    }
    this.authService.goToLogin();
  }
}
